// Counter.tsx
import React, { useEffect, useState } from 'react';
import { toastInfo } from '../utils/toasts';

interface Props {
  onValueChange?: (newValue: number) => void;
  upperLimit?: number;
  initialValue?: number;
}

const Counter: React.FC<Props> = ({
  onValueChange, upperLimit, initialValue = 0,
}) => {
  const [count, setCount] = useState(initialValue);

  useEffect(() => {
    setCount(initialValue);
  }, [initialValue]);

  const handleUpdateCount = (addValue: number) => {
    if ((upperLimit && (count + addValue > upperLimit))) {
      toastInfo('Cantidad máxima alcanzada');
      return;
    }
    if (count + addValue < 0) {
      toastInfo('Cantidad mínima alcanzada');
      return;
    }

    setCount((value) => value + addValue);
  };

  useEffect(() => {
    if (onValueChange) {
      onValueChange(count);
    }
  }, [count]);

  return (
    <div className="flex items-center border-none rounded-lg border-gradient-brand text-text-primary text-xl">
      <button
        onClick={() => handleUpdateCount(-1)}
        className="px-3 py-5 text-sm bg-surface-secondary hover:bg-surface-tertiary rounded-l-lg focus:outline-none h-8 flex items-center justify-center"
      >
        –
      </button>
      <span className="px-3 py-5 text-sm h-8 flex items-center justify-center bg-surface-secondary">{count}</span>
      <button
        onClick={() => handleUpdateCount(1)}
        className="px-3 py-5 text-sm bg-surface-secondary hover:bg-surface-tertiary rounded-r-lg focus:outline-none h-8 flex items-center justify-center"
      >
        +
      </button>
    </div>
  );
};

export default Counter;
